module.exports = __webpack_public_path__ + "92c8bd0292d251ee947f398e636802df-email_2x.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/pages/resources/assets/email_2x.png
// module id = 775
// module chunks = 0